import {
  SCRIBE_BOOKING_EVENTS,
  SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS,
  SCRIBE_BULK_UPLOAD_REVIEW_EVENTS,
  SCRIBE_DELIVERY_DETAILS_EVENTS,
  SCRIBE_DELIVERY_OPTIONS_EVENTS,
  SCRIBE_HOME_EVENTS,
  SCRIBE_OFFER_DETAILS_EVENTS,
  SCRIBE_OFFER_ENTER_CODE_DETAILS,
  SCRIBE_POI_SEARCH_EVENTS,
  SCRIBE_REVIEW_OFFER_LIST_EVENTS,
  SCRIBE_STATE_NAMES,
} from 'applications/scribe/instrumentations/track';
import Duck from 'extensible-duck';

export default new Duck({
  namespace: 'GEWEB',
  store: 'SCRIBE',
  types: [
    'EXPRESS_HOMEPAGE_WEB_GENERIC',

    'EXPRESS_BULK_UPLOAD_REVIEW_DEFAULT',
    'EXPRESS_BULK_UPLOAD_EDIT_ADDRESS',
    'EXPRESS_EDIT_ADDRESS_WEB_ADDRESS',

    'EXPRESS_HOMEPAGE_WEB_MULTI_BOOK',
    'EXPRESS_HOMEPAGE_WEB_PICKUP_ADDRESS',
    'EXPRESS_HOMEPAGE_WEB_SWAP',
    'EXPRESS_HOMEPAGE_WEB_DROPOFF_ADDRESS',
    'EXPRESS_HOMEPAGE_WEB_SERVICE_TYPE',
    'EXPRESS_HOMEPAGE_WEB_CONFIRM_BOOKING',
    'EXPRESS_HOMEPAGE_WEB_ONGOING_ORDER',
    'EXPRESS_HOMEPAGE_WEB_RECENT_ORDER',
    'EXPRESS_HOMEPAGE_WEB_SELECT_POI_FROM_DELIVER_TO',

    'EXPRESS_BOOKINGS_WEB_BOOK_AGAIN',
    'EXPRESS_BOOKINGS_WEB_PRINT_LABEL',
    'EXPRESS_BOOKINGS_WEB_BULK_PRINT_LABEL',
    'EXPRESS_BOOKINGS_WEB_ONGOING_SECTION',
    'EXPRESS_BOOKINGS_WEB_SHOW_ONGOING_BOOKINGS',
    'EXPRESS_BOOKINGS_WEB_ONGOING_BOOKINGS_FILTER',
    'EXPRESS_BOOKINGS_WEB_ONGOING_BOOKINGS_STATUS',
    'EXPRESS_BOOKINGS_WEB_ONGOING_TABLE_ACTION',
    'EXPRESS_BOOKINGS_WEB_HISTORY_TABLE_ACTION',
    'EXPRESS_BOOKINGS_WEB_HISTORY_BOOKINGS_STATUS',
    'EXPRESS_BOOKINGS_WEB_HISTORY_BOOKINGS_DATE',
    'EXPRESS_BOOKINGS_WEB_SHOPIFY',

    'EXPRESS_DELIVERY_OPTIONS_GENERIC',
    'EXPRESS_DELIVERY_OPTIONS_DELIVERY_TYPE',
    'EXPRESS_DELIVERY_OPTIONS_VEHICLE_TYPE',
    'EXPRESS_DELIVERY_OPTIONS_PICKUP_DATE',
    'EXPRESS_DELIVERY_OPTIONS_PICKUP_TIME',
    'EXPRESS_DELIVERY_OPTIONS_CONFIRM',

    'EXPRESS_POI_SEARCH_WEB_DEFAULT',
    'EXPRESS_POI_SEARCH_WEB_ADD_STOP',
    'EXPRESS_POI_SEARCH_WEB_CONFIRM',
    'EXPRESS_POI_SEARCH_WEB_MAP_SEARCH_RESULT',
    'EXPRESS_POI_SEARCH_WEB_SELECT_POI_FROM_RESULT',
    'EXPRESS_POI_SEARCH_WEB_SELECT_POI_FIND_SHORTEST_ROUTE',
    'EXPRESS_POI_SEARCH_WEB_SELECT_POI_FIND_SHORTEST_ROUTE_RESULTS',
    'EXPRESS_POI_SEARCH_WEB_SELECT_POI_USE_ORIGINAL_ROUTE',

    'EXPRESS_DELIVERY_DETAILS_FORM_CHANGE',
    'EXPRESS_DELIVERY_DETAILS_PICKUP_ADDRESS',
    'EXPRESS_DELIVERY_DETAILS_DROPOFF_ADDRESS',
    'EXPRESS_DELIVERY_DETAILS_DUPLICATE_DELIVERY',
    'EXPRESS_DELIVERY_DETAILS_EDIT_DELIVERY',
    'EXPRESS_DELIVERY_DETAILS_ADD_ON',
    'EXPRESS_DELIVERY_DETAILS_DELETE_ADD_ON',
    'EXPRESS_DELIVERY_DETAILS_ADD_DELIVERY_LEFT',
    'EXPRESS_DELIVERY_DETAILS_ADD_DELIVERY_BOTTOM',
    'EXPRESS_DELIVERY_DETAILS_LEFT_BAR',
    'EXPRESS_DELIVERY_DETAILS_DELETE_DELIVERY',
    'EXPRESS_DELIVERY_DETAILS_BOOK',
    'EXPRESS_DELIVERY_DETAILS_APPLY_OFFER',

    'EXPRESS_REVIEW_OFFER_LIST_DEFAULT',
    'EXPRESS_REVIEW_OFFER_LIST_BACK',
    'EXPRESS_REVIEW_OFFER_LIST_ENTER_OFFER_CODE',
    'EXPRESS_REVIEW_OFFER_LIST_CHECK_OFFER_DETAILS',
    'EXPRESS_REVIEW_OFFER_LIST_SELECT_OFFER',
    'EXPRESS_REVIEW_OFFER_LIST_APPLY_OFFER',
    'EXPRESS_REVIEW_OFFER_LIST_CONTINUE_WITHOUT_OFFER',

    'EXPRESS_OFFER_DETAILS_DEFAULT',
    'EXPRESS_OFFER_DETAILS_BACK',
    'EXPRESS_OFFER_DETAILS_USE_OFFER',

    'EXPRESS_ENTER_CODE_DETAILS_BACK',
    'EXPRESS_ENTER_CODE_DETAILS_TYPE_CODE',
    'EXPRESS_ENTER_CODE_DETAILS_SHOW_ERROR_RESULT',
    'EXPRESS_ENTER_CODE_DETAILS_SELECT_OFFER',
    'EXPRESS_ENTER_CODE_DETAILS_APPLY_OFFER',
    'EV_REGULATION_EVENT',
  ],
  reducer: (state, action, duck) => state,
  creators: duck => ({
    /// EXPRESS_HOMEPAGE_WEB
    scribeExpressHomePageWebViewRecentUpdates: () => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_GENERIC,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.VIEW_RECENT_UPDATES,
    }),
    scribeExpressHomePageWebServiceType: () => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_SERVICE_TYPE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.SERVICE_TYPE,
    }),
    scribeExpressBulkUploadReviewDefault: (
      uploadTotal,
      batchRefs,
      bookingNumbers,
    ) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_REVIEW_DEFAULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_BULK_UPLOAD_REVIEW_EVENTS.DEFAULT,
      uploadTotal,
      batchRefs,
      bookingNumbers,
    }),
    scribeExpressBulkUploadReviewEditAddress: (
      originalAddress,
      adjustedToAddress,
      isSender,
      orderBatchRef,
    ) => ({
      type: duck.types.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_REVIEW_WEB,
      eventName: SCRIBE_BULK_UPLOAD_REVIEW_EVENTS.EDIT_ADDRESS,
      originalAddress,
      adjustedToAddress,
      isSender,
      orderBatchRef,
    }),
    scribeExpressBulkUploadEditAddressWebAddress: adjustedToAddress => ({
      type: duck.types.EXPRESS_EDIT_ADDRESS_WEB_ADDRESS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_EDIT_ADDRESS_WEB,
      eventName: SCRIBE_BULK_UPLOAD_EDIT_ADDRESS_EVENTS.ADDRESS,
      adjustedToAddress,
    }),
    scribeExpressHomePageWebPickupAddress: deliveryDetail => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_PICKUP_ADDRESS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.PICKUP_ADDRESS,
      deliveryDetail,
    }),
    scribeExpressHomePageSwapDeliveryPickUpDropOff: deliveryDetail => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_SWAP,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.SWAP,
      deliveryDetail,
    }),
    scribeExpressHomePageWebDropoffAddress: deliveryDetail => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_DROPOFF_ADDRESS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.DROPOFF_ADDRESS,
      deliveryDetail,
    }),
    scribeExpressHomePageWebConfirmBooking: deliveryDetail => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_CONFIRM_BOOKING,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.CONFIRM,
      deliveryDetail,
    }),
    scribeExpressHomePageWebOngoingOrder: () => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_ONGOING_ORDER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.VIEW_ONGOING,
    }),
    scribeExpressHomePageWebRecentOrder: () => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_RECENT_ORDER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.VIEW_UPCOMING,
    }),
    scribeExpressHomePageMultipleBookings: () => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_MULTI_BOOK,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.MULTIPLE_BOOKINGS,
    }),

    /// EXPRESS_BOOKINGS_WEB

    scribeExpressBookingsWebBookAgain: order => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_BOOK_AGAIN,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.BOOK_AGAIN,
      order,
    }),

    scribeExpressBookingsWebPrintLabel: () => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_PRINT_LABEL,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.PRINT_LABEL,
    }),

    scribeExpressBookingsWebBulkPrintLabel: orderCount => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_BULK_PRINT_LABEL,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.BULK_PRINT_LABEL,
      orderCount,
    }),

    scribeExpressBookingsWebOngoingSection: ongoingTotal => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_ONGOING_SECTION,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.DEFAULT,
      ongoingTotal,
    }),

    scribeExpressBookingsWebShowOngoingBookings: selectedPageSize => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_SHOW_ONGOING_BOOKINGS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.SHOW_ONGOING_BOOKINGS,
      selectedPageSize,
    }),

    scribeExpressBookingsWebOngoingBookingsFilter: orderType => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_ONGOING_BOOKINGS_FILTER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.ONGOING_BOOKINGS_FILTER,
      orderType,
    }),

    scribeExpressBookingsWebOngoingBookingsStatus: () => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_ONGOING_BOOKINGS_STATUS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.ONGOING_BOOKINGS_STATUS,
    }),

    scribeExpressBookingsWebOngoingTableAction: order => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_ONGOING_TABLE_ACTION,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.ONGOING_BOOKINGS_DETAILS,
      order,
    }),

    scribeExpressBookingsWebHistoryTableAction: order => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_HISTORY_TABLE_ACTION,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.PAST_BOOKINGS_DETAILS,
      order,
    }),

    scribeExpressBookingsWebHistoryBookingsStatus: () => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_HISTORY_BOOKINGS_STATUS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.PAST_BOOKINGS_STATUS,
    }),

    scribeExpressBookingsWebHistoryBookingsDate: () => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_HISTORY_BOOKINGS_DATE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BOOKINGS_WEB,
      eventName: SCRIBE_BOOKING_EVENTS.DATE_RANGE,
    }),

    scribeExpressBookingsWebShopify: (stateName, eventName, facets = {}) => ({
      type: duck.types.EXPRESS_BOOKINGS_WEB_SHOPIFY,
      stateName,
      eventName,
      facets,
    }),

    /// EXPRESS_DELIVERY_OPTIONS

    scribeExpressDeliveryOptionsBack: () => ({
      type: duck.types.EXPRESS_DELIVERY_OPTIONS_GENERIC,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_OPTIONS,
      eventName: SCRIBE_DELIVERY_OPTIONS_EVENTS.BACK,
    }),

    scribeExpressDeliveryDeliveryType: serviceType => ({
      type: duck.types.EXPRESS_DELIVERY_OPTIONS_DELIVERY_TYPE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_OPTIONS,
      eventName: SCRIBE_DELIVERY_OPTIONS_EVENTS.DELIVERY_TYPE,
      serviceType,
    }),

    scribeExpressDeliveryVehicleType: vehicleType => ({
      type: duck.types.EXPRESS_DELIVERY_OPTIONS_VEHICLE_TYPE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_OPTIONS,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.VEHICLE_TYPE,
      vehicleType,
    }),

    scribeExpressDeliverySelectPickupDate: () => ({
      type: duck.types.EXPRESS_DELIVERY_OPTIONS_PICKUP_DATE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_OPTIONS,
      eventName: SCRIBE_DELIVERY_OPTIONS_EVENTS.SELECT_PICKUP_DATE,
    }),

    scribeExpressDeliverySelectPickupTime: () => ({
      type: duck.types.EXPRESS_DELIVERY_OPTIONS_PICKUP_TIME,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_OPTIONS,
      eventName: SCRIBE_DELIVERY_OPTIONS_EVENTS.SELECT_PICKUP_TIME,
    }),

    scribeExpressDeliveryConfirm: () => ({
      type: duck.types.EXPRESS_DELIVERY_OPTIONS_CONFIRM,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_OPTIONS,
      eventName: SCRIBE_DELIVERY_OPTIONS_EVENTS.CONFIRM,
    }),

    // EXPRESS_POI_SEARCH_WEB

    scribeExpressPOISearchWebAddStop: () => ({
      type: duck.types.EXPRESS_POI_SEARCH_WEB_ADD_STOP,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_POI_SEARCH_WEB,
      eventName: SCRIBE_POI_SEARCH_EVENTS.ADD_STOP,
    }),

    scribeExpressPOISearchMapSearchResult: ({
      latitude,
      longitude,
      poiType,
      poiID,
    }) => ({
      type: duck.types.EXPRESS_POI_SEARCH_WEB_MAP_SEARCH_RESULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_POI_SEARCH_WEB,
      eventName: SCRIBE_POI_SEARCH_EVENTS.MAP_SEARCH_RESULT,
      latitude,
      longitude,
      poiType,
      poiID,
    }),

    scribeExpressPOISearchWebConfirm: (deliveryID, isPickUp) => ({
      type: duck.types.EXPRESS_POI_SEARCH_WEB_CONFIRM,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_POI_SEARCH_WEB,
      eventName: SCRIBE_POI_SEARCH_EVENTS.CONFIRM,
      deliveryID,
      isPickUp,
    }),

    scribeExpressPOISelectPOIFromResult: ({
      poiType,
      keyword,
      selectedPOI,
      selectedIndex,
      candidatePOIs,
      version,
      isRecommendedPoi,
      poiCategory,
      poiLabel,
    }) => ({
      type: duck.types.EXPRESS_POI_SEARCH_WEB_SELECT_POI_FROM_RESULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_POI_SEARCH_WEB,
      eventName: SCRIBE_POI_SEARCH_EVENTS.SELECT_POI_FROM_RESULT,
      poiType,
      keyword,
      selectedPOI,
      selectedIndex,
      candidatePOIs,
      version,
      isRecommendedPoi,
      poiCategory,
      poiLabel,
    }),

    scribeExpressPOIFindShortestRoute: deliveryID => ({
      type: duck.types.EXPRESS_POI_SEARCH_WEB_SELECT_POI_FIND_SHORTEST_ROUTE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_POI_SEARCH_WEB,
      eventName: SCRIBE_POI_SEARCH_EVENTS.FIND_SHORTEST_ROUTE,
      deliveryID,
    }),

    scribeExpressPOIFindShortestRouteResults: (deliveryID, status) => ({
      type:
        duck.types
          .EXPRESS_POI_SEARCH_WEB_SELECT_POI_FIND_SHORTEST_ROUTE_RESULTS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_POI_SEARCH_WEB,
      eventName: SCRIBE_POI_SEARCH_EVENTS.FIND_SHORTEST_ROUTE_RESULTS,
      deliveryID,
      status,
    }),

    scribeExpressPOIUseOriginalRoute: deliveryID => ({
      type: duck.types.EXPRESS_POI_SEARCH_WEB_SELECT_POI_USE_ORIGINAL_ROUTE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_POI_SEARCH_WEB,
      eventName: SCRIBE_POI_SEARCH_EVENTS.USE_ORIGINAL_ROUTE,
      deliveryID,
    }),

    /// EXPRESS_DELIVERY_DETAILS_WEB

    scribeExpressDeliveryDetailFormChange: payload => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_FORM_CHANGE,
      payload,
    }),

    scribeExpressDeliveryDetailDuplicateDelivery: index => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_DUPLICATE_DELIVERY,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.DUPLICATE_DELIVERY,
      index,
    }),

    scribeExpressDeliveryDetailEditDelivery: deliveryID => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_EDIT_DELIVERY,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.EDIT_DELIVERY,
      deliveryID,
    }),

    scribeExpressDeliveryDetailAddOn: ({ deliveryID }) => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_ADD_ON,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.ADD_ON,
      deliveryID,
    }),

    scribeExpressDeliveryDetailDeleteAddOn: ({ deliveryID }) => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_DELETE_ADD_ON,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.DELETE_ADD_ON,
      deliveryID,
    }),

    scribeExpressDeliveryDetailPickUpAddress: ({ index, deliveryID }) => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_PICKUP_ADDRESS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.PICKUP_ADDRESS,
      index,
      deliveryID,
    }),

    scribeExpressDeliveryDetailDropOffAddress: ({ index, deliveryID }) => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_DROPOFF_ADDRESS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.DROPOFF_ADDRESS,
      index,
      deliveryID,
    }),

    scribeExpressDeliveryDetailAddDeliveryLeft: () => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_ADD_DELIVERY_LEFT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.ADD_DELIVERY_LEFT,
    }),

    scribeExpressDeliveryDetailAddDeliveryBottom: () => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_ADD_DELIVERY_BOTTOM,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.ADD_DELIVERY_BOTTOM,
    }),

    scribeExpressDeliveryDetailLeftBar: index => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_LEFT_BAR,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.LEFT_BAR,
      index,
    }),

    scribeExpressDeliveryDetailDeleteDelivery: index => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_DELETE_DELIVERY,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.DELETE_DELIVERY,
      index,
    }),

    scribeExpressDeliveryDetailBook: createDeliveryIDs => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_BOOK,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.BOOK,
      createDeliveryIDs,
    }),

    scribeExpressDeliveryDetailApplyOffer: index => ({
      type: duck.types.EXPRESS_DELIVERY_DETAILS_APPLY_OFFER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB,
      eventName: SCRIBE_DELIVERY_DETAILS_EVENTS.APPLY_OFFER,
      index,
    }),

    /// OFFER
    scribeExpressReviewOfferListDefault: selectedOffer => ({
      type: duck.types.EXPRESS_REVIEW_OFFER_LIST_DEFAULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_REVIEW_OFFER_LIST,
      eventName: SCRIBE_REVIEW_OFFER_LIST_EVENTS.DEFAULT,
      selectedOffer,
    }),
    scribeExpressReviewOfferListBack: selectedOffer => ({
      type: duck.types.EXPRESS_REVIEW_OFFER_LIST_BACK,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_REVIEW_OFFER_LIST,
      eventName: SCRIBE_REVIEW_OFFER_LIST_EVENTS.BACK,
      selectedOffer,
    }),
    scribeExpressReviewOfferListEnterPromoCode: selectedOffer => ({
      type: duck.types.EXPRESS_REVIEW_OFFER_LIST_ENTER_OFFER_CODE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_REVIEW_OFFER_LIST,
      eventName: SCRIBE_REVIEW_OFFER_LIST_EVENTS.ENTER_OFFER_CODE,
      selectedOffer,
    }),
    scribeExpressReviewOfferListCheckOfferDetails: (
      selectedOffer,
      currentOfferID,
    ) => ({
      type: duck.types.EXPRESS_REVIEW_OFFER_LIST_CHECK_OFFER_DETAILS,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_REVIEW_OFFER_LIST,
      eventName: SCRIBE_REVIEW_OFFER_LIST_EVENTS.CHECK_OFFER_DETAILS,
      selectedOffer,
      currentOfferID,
    }),
    scribeExpressReviewOfferListSelectOffer: (
      selectedOffer,
      currentOfferID,
    ) => ({
      type: duck.types.EXPRESS_REVIEW_OFFER_LIST_SELECT_OFFER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_REVIEW_OFFER_LIST,
      eventName: SCRIBE_REVIEW_OFFER_LIST_EVENTS.SELECT_OFFER,
      selectedOffer,
      currentOfferID,
    }),
    scribeExpressReviewOfferListApplyOffer: appliedOfferResult => ({
      type: duck.types.EXPRESS_REVIEW_OFFER_LIST_APPLY_OFFER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_REVIEW_OFFER_LIST,
      eventName: SCRIBE_REVIEW_OFFER_LIST_EVENTS.APPLY_OFFER,
      appliedOfferResult,
    }),
    scribeExpressReviewOfferListContinueWithoutOffer: selectedOffer => ({
      type: duck.types.EXPRESS_REVIEW_OFFER_LIST_CONTINUE_WITHOUT_OFFER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_REVIEW_OFFER_LIST,
      eventName: SCRIBE_REVIEW_OFFER_LIST_EVENTS.CONTINUE_WITHOUT_OFFER,
      selectedOffer,
    }),
    scribeExpressOfferDetailsDefault: (selectedOffer, currentOfferID) => ({
      type: duck.types.EXPRESS_OFFER_DETAILS_DEFAULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_OFFER_DETAILS,
      eventName: SCRIBE_OFFER_DETAILS_EVENTS.DEFAULT,
      selectedOffer,
      currentOfferID,
    }),
    scribeExpressOfferDetailsBack: (selectedOffer, currentOfferID) => ({
      type: duck.types.EXPRESS_OFFER_DETAILS_BACK,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_OFFER_DETAILS,
      eventName: SCRIBE_OFFER_DETAILS_EVENTS.BACK,
      selectedOffer,
      currentOfferID,
    }),
    scribeExpressOfferDetailsUseOffer: (selectedOffer, currentOfferID) => ({
      type: duck.types.EXPRESS_OFFER_DETAILS_USE_OFFER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_OFFER_DETAILS,
      eventName: SCRIBE_OFFER_DETAILS_EVENTS.USE_OFFER,
      selectedOffer,
      currentOfferID,
    }),

    scribeExpressEnterCodeDetailsBack: selectedOffer => ({
      type: duck.types.EXPRESS_ENTER_CODE_DETAILS_BACK,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_ENTER_CODE_DETAILS,
      eventName: SCRIBE_OFFER_ENTER_CODE_DETAILS.BACK,
      selectedOffer,
    }),
    scribeExpressEnterCodeDetailsTypeCode: (selectedOffer, typeCode) => ({
      type: duck.types.EXPRESS_ENTER_CODE_DETAILS_TYPE_CODE,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_ENTER_CODE_DETAILS,
      eventName: SCRIBE_OFFER_ENTER_CODE_DETAILS.TYPE_CODE,
      selectedOffer,
      typeCode,
    }),
    scribeExpressEnterCodeDetailsShowErrorResult: (
      selectedOffer,
      typeCode,
      codeError,
    ) => ({
      type: duck.types.EXPRESS_ENTER_CODE_DETAILS_SHOW_ERROR_RESULT,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_ENTER_CODE_DETAILS,
      eventName: SCRIBE_OFFER_ENTER_CODE_DETAILS.SHOW_ERROR_RESULT,
      selectedOffer,
      typeCode,
      codeError,
    }),
    scribeExpressEnterCodeDetailsSelectOffer: (selectedOffer, codeUsed) => ({
      type: duck.types.EXPRESS_ENTER_CODE_DETAILS_SELECT_OFFER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_ENTER_CODE_DETAILS,
      eventName: SCRIBE_OFFER_ENTER_CODE_DETAILS.SELECT_OFFER,
      selectedOffer,
      codeUsed,
    }),
    scribeExpressEnterCodeDetailsApplyOffer: (
      selectedOffer,
      codeError,
      codeUsed,
    ) => ({
      type: duck.types.EXPRESS_ENTER_CODE_DETAILS_APPLY_OFFER,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_ENTER_CODE_DETAILS,
      eventName: SCRIBE_OFFER_ENTER_CODE_DETAILS.APPLY_OFFER,
      selectedOffer,
      codeError,
      codeUsed,
    }),
    scribeExpressSavedPOISelectPOIFromDeliverTo: (
      deliverToIndex,
      savedPoiNumber,
      favoritesPredictFlag,
    ) => ({
      type: duck.types.EXPRESS_HOMEPAGE_WEB_SELECT_POI_FROM_DELIVER_TO,
      stateName: SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB,
      eventName: SCRIBE_HOME_EVENTS.SELECT_POI_FROM_DELIVER_TO,
      deliverToIndex,
      savedPoiNumber,
      favoritesPredictFlag,
    }),
    scribeEVRegulationEvent: ({ stateName, eventName, errorCode, title }) => {
      let finalStateName = stateName;
      if (!finalStateName && window && window.location) {
        const { pathname } = window.location;
        if (pathname.includes('/bookings/new')) {
          finalStateName = SCRIBE_STATE_NAMES.EXPRESS_DELIVERY_DETAILS_WEB;
        } else if (pathname.includes('/book/bulk-upload')) {
          finalStateName = SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_WEB;
        } else {
          finalStateName = SCRIBE_STATE_NAMES.EXPRESS_HOMEPAGE_WEB;
        }
      }
      return {
        type: duck.types.EV_REGULATION_EVENT,
        stateName: finalStateName,
        eventName,
        errorCode,
        title,
      };
    },
  }),
});
